/* eslint-disable import/prefer-default-export */
export const STORAGE_KEYS = {
  customPreset: 'PagesBeatboxShareCustomPreset',
};
